import {BaseApiResponseModel} from "./base-api-response-model";
import {BaseApiRequestParams} from "./params/base-api-request-params";
import {BaseApiRequestModel} from "./base-api-request-model";

export class BaseDomainRequest extends BaseApiRequestModel {
  timeoutId: Number;

  constructor(params: BaseApiRequestParams, promise: Promise<BaseApiResponseModel>, response: BaseApiResponseModel) {
    super(null, params, promise, response);

    this.timeoutId = null;
  }
}
